/*
  Module configuration file
 */
import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {ObjectUtils} from "../../utils/object-utils";
// *Geo.js Properties*
@JsonObject()
export class ModuleConfiguration {
    // the type of the custom configuration class as string
    // the custom class has to be derived from ModuleConfiguration
    @JsonProperty()
    declare configType: string;

    @JsonProperty()
    declare appName: string;

    @JsonProperty()
    declare title: string;

    constructor() {}

    updateConfig(topicConfig: ModuleConfiguration): void {
        for (const key in topicConfig) {
            if(topicConfig[key as keyof ModuleConfiguration] == null){
                this[key] = topicConfig[key as keyof ModuleConfiguration];
            } else if(this.hasOwnProperty(key) && !Array.isArray(topicConfig[key as keyof ModuleConfiguration])){
                this[key as keyof ModuleConfiguration] = ObjectUtils.mergeDeep(
                    this[key as keyof ModuleConfiguration], topicConfig[key as keyof ModuleConfiguration]);
            }else{
                this[key] = topicConfig[key as keyof ModuleConfiguration];
            }
        }
    }
}
